import { QuoteResponse } from "@deliverr/freight-client";
import { createActionCreator } from "common/ReduxUtils";
import { StorageSelectShippingActionTypes } from "../StorageSelectShippingActionTypes";

export const setSelectedQuoteDetails = createActionCreator<QuoteResponse>(
  StorageSelectShippingActionTypes.STORAGE_SET_SELECTED_QUOTE_DETAILS,
  "selectedQuoteDetails"
);
